import { render, staticRenderFns } from "./UpdateLogo.vue?vue&type=template&id=7ef53b56&scoped=true&"
import script from "./UpdateLogo.vue?vue&type=script&lang=ts&"
export * from "./UpdateLogo.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateLogo.vue?vue&type=style&index=0&id=7ef53b56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef53b56",
  null
  
)

export default component.exports